import React from 'react';
import errorWarning from '../../../assets/error-warning.svg';
import './ErrorMessage.scss';

const ErrorMessage = ({ error }: { error: string }) => {
    return (
        <span className="support-error-message" role="alert">
            <img src={errorWarning} alt="" />
            <span>{error}</span>
        </span>
    );
};

export default ErrorMessage;
